import { api } from 'app/config/apiConfig';
import { AUTH_RESET_PASSWORD_PATH } from '../utils/constants';

interface Args {
  resetSessionId: string;
  code: string;
}

export interface VerifyResetPasswordResponse {
  resetSessionId: string;
}

export const verifyResetPasswordApi = api.injectEndpoints({
  endpoints: (builder) => ({
    verifyResetPassword: builder.mutation<VerifyResetPasswordResponse, Args>({
      query: (args) => ({
        url: `${AUTH_RESET_PASSWORD_PATH}/verify`,
        method: 'POST',
        body: args,
      }),
    }),
  }),
});

export const { useVerifyResetPasswordMutation } = verifyResetPasswordApi;
